import { concat, without, compact } from "lodash"

/************************************
 * ACTION TYPE
 ************************************/
const REDUX_PAGE_LOADING = "REDUX_PAGE_LOADING"
const REDUX_PAGE_REGIST_ID = "REDUX_PAGE_REGIST_ID"
const REDUX_PAGE_LOADED_ID = "REDUX_PAGE_LOADED_ID"
const REDUX_PAGE_LOAD_CANCEL = "REDUX_PAGE_LOAD_CANCEL"

/************************************
 * TYPES
 ************************************/
type LoadType = {
  type:
    | "REDUX_PAGE_LOADING"
    | "REDUX_PAGE_REGIST_ID"
    | "REDUX_PAGE_LOADED_ID"
    | "REDUX_PAGE_LOAD_CANCEL"
  id?: string
  load?: boolean
}

export type LoadStateType = {
  load: boolean
  id?: Array<string>
}

type PageLoadType = () => LoadType
type PageLoadRegist = (id: string, isRegist: boolean) => LoadType

/************************************
 * ACTIONS
 ************************************/
export const pageLoad: PageLoadType = () => {
  return {
    type: REDUX_PAGE_LOADING,
  }
}

export const pageLoadRegist: PageLoadRegist = (id, isRegist) => {
  if (!id) return
  return {
    type: isRegist ? REDUX_PAGE_REGIST_ID : REDUX_PAGE_LOADED_ID,
    id: id,
  }
}

export const cancelLoad: PageLoadType = () => {
  return {
    type: REDUX_PAGE_LOAD_CANCEL,
  }
}

/************************************
 * Reducer
 ************************************/
const initialState: LoadStateType = {
  load: false,
  id: [],
}

export default (state = initialState, action: LoadType) => {
  switch (action.type) {
    case REDUX_PAGE_LOADING:
      return {
        load: true,
      }
    case REDUX_PAGE_REGIST_ID:
      const stateId: Array<string> = concat(state.id, action.id)
      return {
        ...state,
        id: stateId,
      }
    case REDUX_PAGE_LOADED_ID:
      const stateArray: Array<string> = compact(without(state.id, action.id))
      return !stateArray.length
        ? {
            load: false,
            id: stateArray,
          }
        : { ...state, id: stateArray }
    case REDUX_PAGE_LOAD_CANCEL:
      return {
        load: false,
        id: [],
      }
    default:
      return state
  }
}
